export default __webpack_public_path__ + "static/media/geckoTerminal.41d7adcc.webp";